import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithResilience } from "./baseQuery";

// Real external consumers: 17 already-migrated `_features` pages' "Export"
// action buttons (via _components/modal/ExportModal) use exportData/
// getExportableFields/checkDuplicateExport; _features/exports/hooks/
// useExportsData.js uses getExports. Kept as one file rather than split
// per-endpoint - same precedent as roleApiSlice.js/permissionApiSlice.js.
// Three endpoints (getExportsFilters, createExport,
// deleteExport) were pruned during the Exports migration - all three were
// confirmed dead with zero consumers anywhere (getExportsFilters was never
// called, the real filter-metadata call goes through dataApiSlice.js;
// createExport was an untagged duplicate of exportData; deleteExport had no
// matching backend route at all).
export const exportApi = createApi({
  reducerPath: "exportApi",
  tagTypes: ["Export"],
  // Shares baseQuery.js with apiSlice.js - previously this instance had no
  // error normalization/timeout/retry/401 handling at all, unlike the main
  // api. See src/_api/baseQuery.js for what it now gets.
  baseQuery: baseQueryWithResilience,
  endpoints: (builder) => ({
    // Fetch exportable include fields for a module
    getExportableFields: builder.query({
      query: (moduleName) => ({
        url: `/export/fields/${moduleName}`,
        method: "GET",
      }),
    }),

    // Check for duplicate exports
    checkDuplicateExport: builder.mutation({
      query: (exportData) => ({
        url: "/export/check-duplicate",
        method: "POST",
        body: exportData,
      }),
    }),

    exportData: builder.mutation({
      query: (exportData) => ({
        url: "/export",
        method: "POST",
        body: exportData,
      }),
      invalidatesTags: ["Export"],
    }),
    // Get exports with pagination and filters
    getExports: builder.query({
      query: (params) => ({
        url: "/export",
        method: "GET",
        params: {
          page: params.page || 1,
          limit: params.limit || 10,
          sort: params.sort || "-createdAt",
          search: params.search || "",
          ...params,
        },
      }),
      providesTags: ["Export"],
    }),

  }),
});

export const {
  useGetExportableFieldsQuery,
  useCheckDuplicateExportMutation,
  useExportDataMutation,
  useGetExportsQuery,
} = exportApi;
